import colors from 'styles/colors';
import { Icon } from 'semantic-ui-react';

interface DimensionResultsScore {
  name: string;
  abbreviation: string;
  user_score: number;
  expert_code: string;
  reliable: boolean;
}

interface DimensionResultsProps {
  dimensions: DimensionResultsScore[];
}

function DimensionResults({ dimensions }: DimensionResultsProps) {
  function getColor(reliable: boolean) {
    return reliable
      ? colors.reliability.passVideo
      : colors.reliability.failedAttempt;
  }

  function getName(reliable: boolean) {
    if (reliable) {
      return 'check';
    }
    return 'close';
  }
  return (
    <>
      {dimensions.map((dimension, idx: number) => {
        return (
          <div
            key={idx}
            className="grid grid-cols-11 mx-1 text-sm md:text-xl bg-white rounded-lg border border-[#F4F8FA] mb-2"
          >
            <div className="col-span-4 py-2 pl-2 flex rounded-tl-lg rounded-bl-lg">
              <div className="grid grid-cols-7 w-full mr-2">
                <div className="col-span-7">
                  <span className="text-sm md:text-base mt-auto mb-auto">
                    <span className="hidden md:inline">{dimension.name}</span>
                    <span className="inline md:hidden ml-6">
                      {dimension.abbreviation}
                    </span>
                  </span>
                </div>
              </div>
            </div>

            <div className="col-span-2 text-center py-2 text-black bg-white">
              <span className="md:text-[22px] font-bold self-center text-sm">
                {dimension.user_score}
              </span>
            </div>

            <div className="col-span-3 text-center py-2 text-black bg-white">
              <span className="md:text-[22px] font-bold self-center text-sm">
                {dimension.expert_code}
              </span>
            </div>

            <div className="col-span-2 text-center font-bold py-2 rounded-tr-lg rounded-br-lg">
              <div className="self-center">
                <div
                  className="text-[24px] text-center self-center"
                  style={{ color: getColor(dimension.reliable) }}
                >
                  <Icon
                    name={getName(dimension.reliable)}
                    size={'small'}
                    className="align-middle"
                    style={{ fontSize: '0.85em' }}
                  />
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </>
  );
}

export default DimensionResults;
